export const TablesNameEnum = {
  JobRequisition: {
    key: "job_requisition",
  },
  TaskType: {
    key: "task_type",
  },
  TaskStatus: {
    key: "task_status",
  },
  Flow: {
    key: "flow",
  },
  Members: {
    key: "member",
  },
  SpaceMembers: {
    key: "space_member",
  },
  TasksVariables: {
    key: "variable",
  },
  TasksAssignedToAssist: {
    key: "tasks_assigned_to_assist",
  },
  TasksAssignedToView: {
    key: "tasks_assigned_to_view",
  },
  Vacant: {
    key: "vacant",
  },
  ChangeRequest: {
    key: "change_requests",
  },
  Approvals: {
    key: "approvals",
  },
};
